export default __webpack_public_path__ + "static/media/icon-social.a13b0ce2.webp";